import { Button, Card, Col, Row } from '@themesberg/react-bootstrap';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Labels from './Labels';
import TableLinkComponent from './TableLinkComponent';

const CustomerDetailHeader = (customerData) => {
  const history = useHistory();
  const individualCustomer = customerData?.customerData;
  return (
    <Col md={12} className={'mt-3'}>
      <Card border='light' className='bg-white shadow-sm mb-4 p-0'>
        <Card.Body>
          <Row className='d-flex align-items-center mb-3'>
            <Col md={12} lg={6}>
              <h5>{individualCustomer?.accountName}</h5>
            </Col>

            <Col
              md={12}
              lg={6}
              className='d-flex'
              style={{ justifyContent: 'flex-end' }}
            >
              <Button
                variant='primary'
                onClick={() => {
                  history.push(
                    `/customers/edit/${individualCustomer.customerId}`
                  );
                }}
              >
                Edit Customer Details
              </Button>
            </Col>
          </Row>
          <Row>
            <Labels
              keyName='Customer Id'
              value={individualCustomer?.customerId}
            />
            <Labels
              keyName='Phone Number'
              value={individualCustomer?.mailMobileNumber}
            />
            <Labels
              keyName='Business Type'
              value={individualCustomer?.occupation}
            />

            {/* {Labels(individualCustomer?.assignedCollectorName)} */}
            <Col md={4} className='mb-3'>
              <h6>{'Assigned Collector'}:</h6>
              <h6 style={{ textDecoration: 'underline' }}>
                <TableLinkComponent
                  value={individualCustomer?.assignedCollectorName}
                  onClick={() =>
                    history.push(
                      `/collectors/profile/${individualCustomer?.assignedCollectorId}`
                    )
                  }
                />
              </h6>
            </Col>
            <Labels
              keyName='Assigned Collector Mobile Number'
              value={individualCustomer?.assignedCollectorMobileNumber}
            />
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default CustomerDetailHeader;
